import * as yup from 'yup'


export const brochure_generator = () => yup.object({
  template: yup.string().required('This field is required').nullable(),
  id__in: yup.array().of(yup.number().integer().min(1)).required('This field is required').nullable()
})
